import { render } from "./CMS.vue?vue&type=template&id=12c8ea94"
import script from "./CMS.vue?vue&type=script&lang=js"
export * from "./CMS.vue?vue&type=script&lang=js"

import exportComponent from "/srv/strapi/LessMessAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__